import { Box } from "@mui/material";
import React, { useEffect, useMemo, useState } from "react";
import { MessageWithId } from "../../store/conversationMessagesSlice";
import { CustomMarkdownRenderer } from "../../../../components/CustomMarkdownRenderer";
import { AgentMessageButtonMenu } from "./AgentMessageButtonMenu";

interface AgentMessageProps {
  message: Extract<MessageWithId, { type: "agent" }>;
  conversationId: string;
}

export const AgentMessageBubble: React.FC<AgentMessageProps> = ({
  message,
  conversationId,
}) => {
  const tokens = message.content.tokens || [];
  const messageComplete = useMemo(() => !!message.content.text, []);
  // Join tokens, filtering out null if present
  const fullText = tokens.filter((t) => t !== null).join("");

  const messageId = `agent-message-${message.id}`;

  const [isHovered, setIsHovered] = useState(false);

  const ref = React.useRef<HTMLSpanElement>(null);

  useEffect(() => {
    if (ref.current && !messageComplete && tokens.length > 0) {
      // Only scroll if the message is not currently visible
      const rect = ref.current.getBoundingClientRect();
      const isVisible = rect.top >= 0 && rect.bottom <= window.innerHeight;
      
      if (!isVisible) {
        ref.current.scrollIntoView({
          behavior: "smooth",
          block: "nearest",
        });
      }
    }
  }, [tokens.length, messageComplete]);

  return (
    <Box
      data-testid="agent-message"
      sx={{
        display: "flex",
        justifyContent: "flex-start",
        mb: 2,
        position: "relative",
      }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <span id={messageId}>
        <CustomMarkdownRenderer content={fullText} />
      </span>
      <AgentMessageButtonMenu
        messageId={messageId}
        conversationId={conversationId}
        isVisible={isHovered}
      />
      <span ref={ref} />
    </Box>
  );
};
